import { render, staticRenderFns } from "./space-exam-compose.vue?vue&type=template&id=9eef2e54&scoped=true"
import script from "./space-exam-compose.vue?vue&type=script&lang=js"
export * from "./space-exam-compose.vue?vue&type=script&lang=js"
import style0 from "./space-exam-compose.vue?vue&type=style&index=0&id=9eef2e54&prod&lang=less&scoped=true"
import style1 from "./space-exam-compose.vue?vue&type=style&index=1&id=9eef2e54&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9eef2e54",
  null
  
)

export default component.exports